<div class="row payoutSchedule">
  <div class="col-md-12">
    <h3 style=" font-weight: 700;font-size: 18px; display: flex; align-items: center;color: #313A44;">Payouts</h3>
    <form class="pt-2">
      <div class="row " *ngIf="payoutSchedule?.payout_schedule?.interval != ''">
        <div class="col-12 mb-1" *ngIf="payoutSchedule?.payout_schedule?.interval != ''">
          Your payout is scheduled on the
          <b>{{ payoutSchedule?.payout_schedule?.interval || "--" }}</b> basis
          <span *ngIf="payoutSchedule?.payout_schedule?.weekly_anchor">
            on {{payoutSchedule?.payout_schedule?.weekly_anchor}}
          </span>.
        </div>
      </div>

      <div class="row" *ngIf="payoutSchedule?.payout_schedule?.interval == '' || can_schedule_payout == 1 ">
        <mat-radio-group name="Daily" [(ngModel)]="payoutType">
          <div class="col-md-12 py-1 mb-1">
            <mat-radio-button value="Daily" (change)="daily()">Daily</mat-radio-button>
          </div>
          <div class="col-md-12 py-1 mb-1">
            <mat-radio-button value="Weekly" (change)="week()">Weekly</mat-radio-button>
          </div>
          <div class="col-md-12 py-1">

            <mat-radio-button value="Monthly" (change)="week()">Monthly</mat-radio-button>
          </div>
        </mat-radio-group>

        <div class="col-12 py-2 mb-3">
          <div class="row">
            <div class="col-6">
              <div class="form-group mt-2 w-75" *ngIf="payoutType == 'Weekly'">
                <div class="wrap m-h-56 h-100 h-56 d-block">
                  <div class="select w-100 h-100 h-56 d-flex justify-content-between align-items-center">
                    <div class="w-100 h-100">
                      <select id="img_logo_emp" [(ngModel)]="payoutDay" name="payoutDay" (change)="changeDay($event)"
                        required class="select-text pt-3 px-3 mt-1 input_field fw-bold m-h-56 h-100 w-100">
                        <option value="monday">Monday</option>
                        <option value="tuesday">Tuesday</option>
                        <option value="wednesday">Wednesday</option>
                        <option value="thursday">Thursday</option>
                        <option value="friday">Friday</option>
                        <option value="saturday">Saturday</option>
                        <option value="sunday">Sunday</option>
                      </select>
                      <span class="select-highlight"></span>
                      <span class="select-bar"></span>
                      <span class="select-bar-1"></span>
                      <span class="select-bar-1"></span>
                      <label class="select-label f-c-p-3">Weekday</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group mt-2 w-75" *ngIf="payoutType == 'Monthly'">
                <div class="wrap m-h-56 h-100 h-56 d-block">
                  <div class="select w-100 h-100 h-56 d-flex justify-content-between align-items-center">
                    <div class="w-100 h-100">
                      <select id="img_logo_emp"[(ngModel)]="payoutDay" name="payoutDay" (change)="changeDay($event)"
                        required class="select-text pt-3 px-3 mt-1 input_field fw-bold m-h-56 h-100 w-100">
                        <option *ngFor="let day of monthday; let i = index"  [value]="i + 1">{{ i + 1 }}</option>
                      </select>
                      <span class="select-highlight"></span>
                      <span class="select-bar"></span>
                      <span class="select-bar-1"></span>
                      <span class="select-bar-1"></span>
                      <label class="select-label f-c-p-3">Date</label>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="col-6 d-flex" style="margin-left: -3rem; margin-top: 1rem; margin-bottom: 1rem;">
              <button mat-raised-button (click)="schedulePayout()" class="px-4 btn-lg scheduled_btn" style="cursor: pointer;">
                Schedule
              </button>
            </div>

          </div>

        </div>
      </div>

      <div class="row">
        <!-- Filed Starts -->

        <div class="col-12 ">Enroll into paper Statements?</div>
        <div class="col-12  py-2">
          <mat-radio-group name="HardCopy" class="py-2" [(ngModel)]="payoutSchedule_1"
            (change)="payoutSchedues($event)">
            <span class="ps-0">
              <mat-radio-button value="0">No</mat-radio-button>
            </span>
            <span class="p-4">
              <mat-radio-button value="1">Yes</mat-radio-button>
            </span>
          </mat-radio-group>

        </div>
        <!-- Field Ends -->
      </div>
    </form>
  </div>
</div>
